import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Avatar,
  Box,
  Grid,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
} from "@mui/material";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import LimitedTextBox from "components/ui/atoms/LimitedTextBox";
import { ColorTag, SourcingStatusTag } from "components/ui/atoms/Tag";

const SourcingListItem = ({ sourcing, onClick }) => {
  return (
    <ListItemButton
      onClick={() => onClick(sourcing.id, sourcing)}
      sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
    >
      <ListItemAvatar>
        <Avatar
          src={`http://logo.clearbit.com/${sourcing.company_detail.best_domain}`}
        >
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <Stack
        direction={{ xs: "row", md: "column" }}
        alignItems={{ xs: "center", md: "start" }}
        spacing={0}
        sx={{
          width: { xs: "calc(100% - 56px)", md: "20%" },
          maxWidth: { xs: "auto", md: "250px" },
          flexGrow: 0,
          flexShrink: 0,
        }}
      >
        <ListItemText
          primary={sourcing.company_detail.best_name}
          secondary={
            <>
              {sourcing.deal_flow_detail.short_name}
              {" - "}
              {sourcing?.sourcing_owner_detail?.initials}
            </>
          }
        />
        <SourcingStatusTag
          status={sourcing.status}
          sx={{ width: "fit-content" }}
        />
      </Stack>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          ml: { xs: 0, md: 2 },
          alignSelf: "stretch",
        }}
      >
        <LimitedTextBox
          title="Description"
          content={sourcing.company_detail?.description}
          limit={5}
        />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          maxWidth: { md: 500 },
          ml: { xs: 0, md: 2 },
          flexShrink: 0,
          flexGrow: 0,
          alignSelf: "stretch",
        }}
      >
        <Grid container spacing={{ xs: 0, md: 3 }} p={0}>
          <Grid size={{ xs: 12, md: 6 }}>
            <LimitedTextBox
              title="Context"
              content={sourcing.context}
              limit={5}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <LimitedTextBox
              title="Actions taken"
              content={sourcing.actions_taken}
              limit={3}
            />
            <LabelValueForTags
              label="Reason to close"
              Tags={
                sourcing?.reason_to_close_tag
                  ? sourcing?.reason_to_close_tag.map((r) => (
                      <ColorTag key={r} tagId={r} />
                    ))
                  : []
              }
              maxTags={1}
              variant="ForListItem"
            />
          </Grid>
        </Grid>
      </Box>
    </ListItemButton>
  );
};

export default SourcingListItem;
